import React, { useContext, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import { get, postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import AddBillers from "../../modals/AddBillers";
import { ddmmyyyy } from "../../utils/DateUtils";
import AuthContext from "../../store/AuthContext";
import { bill } from "../../iconsImports";
import useCommonContext from "../../store/CommonContext";
import { validateApiCall } from "../../utils/LastApiCallChecker";
import BillDetailsModal from "../../modals/BillDetailsModal";
import Loader from "../../component/loading-screen/Loader";
import PayBill from "./PayBill";
import CachedIcon from "@mui/icons-material/Cached";
import UpdateBiller from "./UpdateBiller";

const BillersView = () => {
  const [request, setRequest] = useState("");
  const [billers, setBillers] = useState([]);
  const authCtx = useContext(AuthContext);
  const [selectedRow, setSelectedRow] = useState(null);
  const [enquiryReferenceId, setEnquiryReferenceId] = useState("");
  const { getRecentData, refreshUser } = useCommonContext();
  const user = authCtx.user;
  const location = authCtx.location;
  const [query, setQuery] = useState("");
  const [categoryKey, setCategoryKey] = useState("");
  const [openPayBill, setOpenPayBill] = useState(false);
  const [paymentTime, setPaymentTime] = useState(null);
  const [openEditBiller, setOpenEditBiller] = useState(false);
  const getBillers = () => {
    get(
      ApiEndpoints.MY_BILLERS,
      "",
      setRequest,
      (res) => {
        setBillers(res.data.data);
        billers.map((item) => {
          setCategoryKey(item.categoryKey);
        });
      },
      (err) => {
        apiErrorToast(err);
      }
    );
  };

  const columns = [
    { key: "id", label: "ID", align: "left" },
    { key: "biller_name", label: "Biller Name", align: "left" },
    { key: "param1", label: "Param1", align: "left" },
    { key: "param2", label: "Param2", align: "left" },
    { key: "param3", label: "Amount", align: "left" },
    { key: "generated_date", label: "Generated Date", align: "center" },
    { key: "due_date", label: "Due Date", align: "center" },
    { key: "last_paid", label: "Last Paid", align: "center" },
    { key: "pay", label: "Actions", align: "center" },
  ];

  const fetchBillOnly = (row) => {
    const data = {
      billerId: row.biller_id,
      latitude: location.lat,
      longitude: location.long,
    };

    const params = ["param1", "param2", "param3", "param4"];
    params.forEach((param) => {
      const value = row[param];
      if (value !== undefined && value !== null && value !== "") {
        data[param] = value;
      }
    });

    postJsonData(
      ApiEndpoints.BBPS_FETCH_BILL,
      data,
      setRequest,
      (res) => {
        okSuccessToast(res.data.message);
        updateBiller(row);
      },
      apiErrorToast
    );
  };
  const openEditModal = (row) => {
    setSelectedRow(row);
    setOpenEditBiller(true);
  };
  const fetchBillAndOpenModal = (row) => {
    const data = {
      billerId: row.biller_id,
      latitude: location.lat,
      longitude: location.long,
    };

    const params = ["param1", "param2", "param3", "param4"];
    params.forEach((param) => {
      const value = row[param];
      if (value !== undefined && value !== null && value !== "") {
        data[param] = value;
      }
    });

    postJsonData(
      ApiEndpoints.BBPS_FETCH_BILL,
      data,
      setRequest,
      (res) => {
        const responseData = res?.data?.data?.data;
        const fetchedEnquiryReferenceId = responseData?.enquiryReferenceId;
        setEnquiryReferenceId(fetchedEnquiryReferenceId);
        setSelectedRow(row);
        setOpenPayBill(true);
        updateBiller(row);
      },
      apiErrorToast
    );
  };

  const updateBiller = (row) => {
    const today = new Date();
    const todayDate = today.toISOString().split("T")[0];

    const formatDate = (date) => {
      if (!date) {
        return null;
      }

      const dateParts = date.split("/");
      if (dateParts.length === 3) {
        const [day, month, year] = dateParts;

        if (day && month && year) {
          return `${year}-${month}-${day}`;
        }
      }

      console.warn("Invalid date format, falling back to null:", date);
      return null;
    };

    const data = {
      id: row.id,
      billerId: row.biller_id,
      operator: row.biller_id,
      amount: row.param3,
      latitude: location.lat,
      longitude: location.long,
      last_paid: formatDate(row.last_paid),
    };

    postJsonData(
      ApiEndpoints.UPDATE_BILLER,
      data,
      setRequest,
      (res) => {
        getRecentData();
        getBillers();
      },
      (error) => {
        apiErrorToast(error);
        getRecentData();
      }
    );
  };

  const refreshFunc = () => {
    setQuery("");
    getBillers();
  };

  useEffect(() => {
    getBillers();
  }, []);

  return (
    <Box style={{ padding: 20, backgroundColor: "#f5f7fa", borderRadius: 10 }}>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <h2 style={{ color: "#333", margin: 0 }}>My Billers</h2>
        <Box style={{ display: "flex" }}>
          <AddBillers getBillers={getBillers} />
          <Tooltip title="refresh">
            <IconButton
              aria-label="refresh"
              sx={{
                color: "#0F52BA",
              }}
              onClick={refreshFunc}
            >
              <CachedIcon className="refresh-purple" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        style={{
          maxHeight: "400px",
          overflowY: "auto",
          borderRadius: "8px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Table aria-label="billers table" stickyHeader>
          <TableHead>
            <Loader loading={request} />
            <TableRow>
              {columns.map((col) => (
                <TableCell
                  key={col.key}
                  align={col.align}
                  style={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "12px 16px",
                    fontSize: "16px",
                    borderBottom: "2px solid #fff",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {billers.map((row) => (
              <TableRow
                key={row.id}
                hover
                style={{
                  backgroundColor: "#f1f8ff",
                  transition: "background-color 0.3s ease",
                }}
              >
                {columns.map((col) => (
                  <TableCell
                    key={col.key}
                    align={col.align}
                    style={{
                      textAlign: col.align,
                      fontSize: "14px",
                      color: "#333",
                      backgroundColor: "#fafbfc",
                      borderBottom: "1px solid #e0e0e0",
                      padding: "12px 16px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {col.key === "pay" ? (
                      <Box display="flex" gap={1}>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => fetchBillOnly(row)}
                          style={{ textTransform: "none", fontSize: "12px" }}
                        >
                          Fetch Bill
                        </Button>
                        <Button
                          variant="contained"
                          onClick={() => fetchBillAndOpenModal(row)}
                          color="success"
                          size="small"
                          style={{ textTransform: "none", fontSize: "12px" }}
                        >
                          Pay ₹{Number(row.param3 || 0).toLocaleString()}
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => openEditModal(row)} // Open the edit modal
                          style={{ textTransform: "none", fontSize: "12px" }}
                        >
                          Edit
                        </Button>
                      </Box>
                    ) : col.key === "created_at" ||
                      col.key === "updated_at" ||
                      col.key === "generated_date" ||
                      col.key === "last_paid" ||
                      col.key === "due_date" ? (
                      row[col.key] ? (
                        ddmmyyyy(row[col.key])
                      ) : (
                        "-"
                      )
                    ) : (
                      row[col.key] ?? "-"
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {openPayBill && selectedRow && (
        <PayBill
          open={openPayBill}
          handleClose={() => setOpenPayBill(false)}
          row={selectedRow}
          fetchedEnquiryReferenceId={enquiryReferenceId}
          setPaymentTime={setPaymentTime}
          paymentTime={paymentTime}
          getBillers={getBillers}
        />
      )}
      {openEditBiller && selectedRow && (
        <UpdateBiller
          open={openEditBiller}
          handleClose={() => setOpenEditBiller(false)}
          row={selectedRow}
          getBillers={getBillers}
        />
      )}
    </Box>
  );
};

export default BillersView;
